import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const requestLocation = createAsyncThunk(
  "user/requestLocation", async (limit, thunkAPI) => {
    try {
      return new Promise((resolve, reject) => {
        const options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        };

        function success(pos) {
          const crd = pos.coords;
          const { latitude, longitude } = crd;
          resolve({ latitude, longitude });
        }

        function error(err) {
          reject({ error: error.message  });
        }

        navigator.geolocation.getCurrentPosition(success, error, options);
      })
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const userLocationSlice = createSlice({
  name: 'userLocation',
  initialState: {
    location: {},
    loading: null,
  },
  extraReducers: (builder) => {
    builder.addCase(requestLocation.pending, (state) => {
      state.location = {};
      state.loading = "loading";
    });
    builder.addCase(
      requestLocation.fulfilled, (state, { payload }) => {
        state.location = payload;
        state.loading = "loaded";
      }
    );
    builder.addCase(
      requestLocation.rejected,(state, action) => {
        state.loading = "error";
        state.error = action.error.message;
      }
    );
  }
})

export default userLocationSlice.reducer;
